import { render, staticRenderFns } from "./expanded-sows.vue?vue&type=template&id=b919e326&scoped=true&lang=pug&"
import script from "./expanded-sows.vue?vue&type=script&lang=ts&"
export * from "./expanded-sows.vue?vue&type=script&lang=ts&"
import style0 from "./expanded-sows.vue?vue&type=style&index=0&id=b919e326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b919e326",
  null
  
)

export default component.exports